import { useState } from 'react';
import { toast } from 'sonner';
import { Bug, Image as ImageIcon, Check, Eye, Copy, Users } from 'lucide-react';
import { APP_INFO } from '../lib/license';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/feedback`;
const hdr = () => ({ 'Content-Type': 'application/json', 'X-Owner-Token': localStorage.getItem('giss_owner_token') || '' });
const OPT_IN = 'https://play.google.com/apps/testing/cc.giss.fieldrapport';
const GROUP = 'https://groups.google.com/a/giss.cc/g/pilot';

// owner: tester reports with screen shot, mark seen / done
export function FeedbackAdmin({ t }) {
  const [list, setList] = useState(null);
  const [imgs, setImgs] = useState({});
  const load = async () => { const r = await fetch(API, { headers: hdr() }); if (!r.ok) { toast.error(t.ownerExpired); return; } setList(await r.json()); };
  const img = async (id) => { const r = await fetch(`${API}/${id}/image`, { headers: hdr() }); if (!r.ok) { toast.error(t.ownerExpired); return; } const u = URL.createObjectURL(await r.blob()); setImgs((m) => ({ ...m, [id]: u })); };
  const status = async (id, s) => { const r = await fetch(`${API}/${id}`, { method: 'PATCH', headers: hdr(), body: JSON.stringify({ status: s }) }); if (!r.ok) { toast.error(t.ownerExpired); return; } setList((l) => l.map((x) => (x.id === id ? { ...x, status: s } : x))); };
  return (
    <section className="fn-box" data-testid="feedback-admin">
      <button className="btn btn-outline btn-sm" data-testid="feedback-admin-load-btn" onClick={load}><Bug size={15} /> {t.fbAdmin}{list ? ` (${list.filter((x) => x.status === 'new').length} ${t.fbNew})` : ''}</button>
      {list && !list.length && <p className="muted" data-testid="feedback-admin-empty">{t.fbNone}</p>}
      {list && list.map((x) => (
        <div key={x.id} className={`fb-item ${x.status}`} data-testid={`feedback-item-${x.id}`}>
          <p className="fb-meta">{new Date(x.at).toLocaleString()} · {x.device_id} · {x.mode || '–'} · v{x.version || '–'} · <b>{t['fbSt_' + x.status]}</b></p>
          <p className="fb-text">{x.text}</p>
          {imgs[x.id] && <a href={imgs[x.id]} target="_blank" rel="noreferrer"><img src={imgs[x.id]} alt="" className="fb-img" data-testid={`feedback-img-${x.id}`} /></a>}
          <div className="row">
            {x.image && !imgs[x.id] && <button className="btn btn-outline btn-sm" data-testid={`feedback-show-img-${x.id}`} onClick={() => img(x.id)}><ImageIcon size={14} /> {t.fbShowImg}</button>}
            {x.status === 'new' && <button className="btn btn-outline btn-sm" data-testid={`feedback-seen-${x.id}`} onClick={() => status(x.id, 'seen')}><Eye size={14} /> {t.fbSt_seen}</button>}
            {x.status !== 'done' && <button className="btn btn-green btn-sm" data-testid={`feedback-done-${x.id}`} onClick={() => status(x.id, 'done')}><Check size={14} /> {t.fbSt_done}</button>}
          </div>
        </div>
      ))}
    </section>
  );
}

const copy = (t, s) => navigator.clipboard.writeText(s).then(() => toast.success(t.copied || 'OK'));
// owner: ready texts for the pilot testers (you send / post them yourself)
export function PilotInvite({ t }) {
  const mail = t.piMail.replaceAll('{group}', GROUP).replaceAll('{optin}', OPT_IN).replaceAll('{app}', APP_INFO.name);
  const post = t.piPost.replaceAll('{group}', GROUP).replaceAll('{optin}', OPT_IN).replaceAll('{app}', APP_INFO.name);
  const Row = ({ k, v }) => <div className="pi-row"><code data-testid={`pilot-${k}`}>{v}</code><button className="icon-btn" data-testid={`pilot-copy-${k}`} onClick={() => copy(t, v)}><Copy size={14} /></button></div>;
  return (
    <details className="fn-box" data-testid="pilot-invite">
      <summary className="btn btn-outline btn-sm"><Users size={15} /> {t.piTitle}</summary>
      <p className="muted small-hint">{t.piSteps}</p>
      <b>{t.piGroup}</b><Row k="group" v={GROUP} />
      <b>{t.piOptin}</b><Row k="optin" v={OPT_IN} />
      <b>{t.piMailT}</b><textarea readOnly rows={9} value={mail} data-testid="pilot-mail-text" /><button className="btn btn-outline btn-sm" data-testid="pilot-copy-mail" onClick={() => copy(t, mail)}><Copy size={14} /> {t.copy}</button>
      <b>{t.piPostT}</b><textarea readOnly rows={10} value={post} data-testid="pilot-post-text" /><button className="btn btn-outline btn-sm" data-testid="pilot-copy-post" onClick={() => copy(t, post)}><Copy size={14} /> {t.copy}</button>
    </details>
  );
}
